// extracted by mini-css-extract-plugin
export default {"legend-traffic-light":"legend-traffic-light-hbgEg","legend-traffic-light__labels":"legend-traffic-light__labels-H1cRe"};